// assets/collection.js
// Equalizes .product-card--root heights within a grid/carousel container.
// Finds the tallest card, writes its height as --product-card-max-height on
// the container; CSS applies it as min-height to every sibling card.

(function () {
  'use strict';

  const CSS_VAR = '--product-card-max-height';
  const CARD_SEL = '.product-card--root';
  // Promo tiles sit in the same grid rows as product cards and must share height
  const PROMO_SEL = '.collection-promo--root';
  // Slick clones are visual duplicates — skip them when measuring
  const CONTAINER_SELECTORS = '.main-collection--grid, .carousel--container, .featured-collection--products, .carousel--block';

  // Fixed card heights per breakpoint.
  const DESKTOP_FIXED_HEIGHT = 558;  // ≥1024px
  const TABLET_FIXED_HEIGHT  = 550;  // 768px–1023px
  const MOBILE_FIXED_HEIGHT  = 345;  // ≤767px

  const MOBILE_MAX = 1024;
  const TABLET_MIN = 768;

  let _rafId = null;

  function equalize(container) {
    if (!container) return;

    // Determine fixed height for the current breakpoint.
    const viewportW = window.innerWidth;
    let fixedH;
    if (viewportW >= MOBILE_MAX) {
      fixedH = DESKTOP_FIXED_HEIGHT;
    } else if (viewportW >= TABLET_MIN) {
      fixedH = TABLET_FIXED_HEIGHT;
    } else {
      fixedH = MOBILE_FIXED_HEIGHT;
    }

    // Apply fixed height to the container CSS var and directly to each card.
    container.style.setProperty(CSS_VAR, fixedH + 'px');
    Array.from(container.querySelectorAll(CARD_SEL)).forEach(function (el) {
      el.style.setProperty('min-height', fixedH + 'px');
    });
    Array.from(container.querySelectorAll(PROMO_SEL)).forEach(function (el) {
      const w = el.getAttribute('data-promo-width');
      if (w === '3' || w === '4') return;
      el.style.setProperty('min-height', fixedH + 'px');
    });
  }

  function equalizeAll() {
    document.querySelectorAll(CONTAINER_SELECTORS).forEach(equalize);
  }

  function scheduleEqualizeAll() {
    cancelAnimationFrame(_rafId);
    _rafId = requestAnimationFrame(equalizeAll);
  }

  // On resize the viewport width changes, so re-equalize at the new breakpoint.
  function onResize() {
    scheduleEqualizeAll();
  }

  // Re-measure on resize (rAF debounce prevents layout thrashing)
  window.addEventListener('resize', onResize, { passive: true });

  // Re-measure after fonts/images are fully loaded (accurate text wrapping)
  window.addEventListener('load', equalizeAll);

  // Shopify Theme Editor: section add / re-render
  document.addEventListener('shopify:section:load', equalizeAll);

  // theme.js fires this after every AJAX filter/sort replaces the grid innerHTML.
  // Without it, the old --product-card-max-height value stays on the container
  // and promo tiles keep their stale min-height from the previous result set.
  window.addEventListener('theme:navigation:reloaded', scheduleEqualizeAll);

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      equalizeAll();

      // Slick initialises asynchronously — watch for .slick-initialized class
      if (window.MutationObserver) {
        new MutationObserver(function (mutations) {
          mutations.forEach(function (m) {
            if (
              m.attributeName === 'class' &&
              m.target.classList.contains('slick-initialized')
            ) {
              const c = m.target.closest?.('.carousel--container');
              if (c) equalize(c);
            }
          });
        }).observe(document.body, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class'],
        });
      }
    });
  } else {
    equalizeAll();
  }
})();
